import BHBenefitRoutes from '@/lib/constants/bh_benefit_route_names';
import BhBenefits from '../../apps/bh_benefits/BhBenefits.vue';
import Generic from '../../apps/bh_benefits/Generic.vue';
import UpgradeFlow from '../../apps/bh_benefits/upgrade/UpgradeFlow.vue';
import VerifyCorporateUpgrade from '../../apps/bh_benefits/upgrade/VerifyCorporateUpgrade.vue';
import ClientSpecific from '../../apps/bh_benefits/ClientSpecific.vue';
import SignUp from '../../apps/bh_benefits/SignUp.vue';
import corporateVerificationGuard from '../guards/corporateVerificationGuard';

const bhBenefitsRoutes = [
  {
    path: '/bh-benefits',
    component: BhBenefits,
    meta: { hideMainHeader: true, skipAuth: true },
    children: [
      {
        name: BHBenefitRoutes.HOME,
        path: '',
        component: Generic,
      },
      {
        name: BHBenefitRoutes.UPGRADE,
        path: 'upgrade',
        component: UpgradeFlow,
        meta: { skipAuth: false },
      },
      {
        name: BHBenefitRoutes.VERIFY,
        path: 'verify/:token',
        component: VerifyCorporateUpgrade,
        beforeEnter: corporateVerificationGuard,
      },
      {
        path: ':slug',
        name: BHBenefitRoutes.SIGNUP,
        component: ClientSpecific,
      },
      {
        name: BHBenefitRoutes.YA_SIGNUP,
        path: ':slug/signup',
        component: SignUp,
        beforeEnter(to, from, next) {
          if (to.query.site === 'years_ahead') {
            next();
          } else {
            next({ name: BHBenefitRoutes.SIGNUP, params: { slug: to.params.slug }, query: to.query });
          }
        },
      },
    ],
  },
];

export default bhBenefitsRoutes;
